export interface PrintSettings {
  menuType: string;
  groupBy: string;
  title: string;
  showDate: boolean;
  showDescription: boolean;
  showLocation: boolean;
  showLogo: boolean;
  columns: number;
  showHandle: boolean;
  sortBy: string;
  showBreweryName: boolean;
  showServings: boolean;
  showServingSize: boolean;
  showServingCurrency: boolean;
  showBeerStyle: boolean;
  tapStart: number;
  tapEnd: number;
  primaryColor: string;
  secondaryColor: string;
  dashColor: string;
  primaryTextColor: string;
  secondaryTextColor: string;
  footerDate: string;
  footerLocation: string;
  footerWebsite: string;
  groupsOrder: number[];
  headerType?: string;
  headerImageUrl?: string;
  footerImageUrl?: string;
}

export const buildPrintUrl = (settings: PrintSettings): string => {
  const params: Record<string, string> = {};

  for (const [key, value] of Object.entries(settings)) {
    if (value !== undefined && value !== null) {
      params[key] = encodeURIComponent(String(value));
    }
  }

  const urlParameters = Object.entries(params)
    .map(([k, v]) => `${k}=${v}`)
    .join('&');

  return `/taps/print?${urlParameters}`;
};

export const buildPrintSettingsFromState = (opts: {
  menuType: string;
  groupBy: string;
  title: string;
  showDate: boolean;
  showDescription: boolean;
  showLocation: boolean;
  showLogo: boolean;
  columns: number;
  showHandle: boolean;
  sortBy: string;
  showBreweryName: boolean;
  showServings: boolean;
  showServingSize: boolean;
  showServingCurrency: boolean;
  showBeerStyle: boolean;
  tapStart: number;
  tapEnd: number;
  primaryColor: string;
  secondaryColor: string;
  dashColor: string;
  primaryTextColor: string;
  secondaryTextColor: string;
  footerDate: string;
  footerLocation: string;
  footerWebsite: string;
  groupOrder: Array<{ index: number }>;
  isCustomMenu: boolean;
  isClassicMenu: boolean;
  isVerticalMenu: boolean;
  classicHeaderType: string;
  verticalHeaderType: string;
  headerImageFile: File | null;
  headerImageUrl: string | undefined;
  footerImageFile: File | null;
  footerImageUrl: string | undefined;
}): PrintSettings => {
  const settings: PrintSettings = {
    menuType: opts.menuType,
    groupBy: opts.groupBy,
    title: opts.title,
    showDate: opts.showDate,
    showDescription: opts.showDescription,
    showLocation: opts.showLocation,
    showLogo: opts.showLogo,
    columns: opts.columns,
    showHandle: opts.showHandle,
    sortBy: opts.sortBy,
    showBreweryName: opts.showBreweryName,
    showServings: opts.showServings,
    showServingSize: opts.showServingSize,
    showServingCurrency: opts.showServingCurrency,
    showBeerStyle: opts.showBeerStyle,
    tapStart: opts.tapStart,
    tapEnd: opts.tapEnd,
    primaryColor: opts.primaryColor,
    secondaryColor: opts.secondaryColor,
    dashColor: opts.dashColor,
    primaryTextColor: opts.primaryTextColor,
    secondaryTextColor: opts.secondaryTextColor,
    footerDate: opts.footerDate,
    footerLocation: opts.footerLocation,
    footerWebsite: opts.footerWebsite,
    groupsOrder: opts.groupOrder.map((group) => group.index)
  };

  if (opts.isCustomMenu) {
    if (opts.isClassicMenu) {
      settings.headerType = opts.classicHeaderType;
    } else if (opts.isVerticalMenu) {
      settings.headerType = opts.verticalHeaderType;
    }

    if (opts.headerImageFile && opts.headerImageUrl) {
      settings.headerImageUrl = opts.headerImageUrl;
    }

    if (opts.footerImageFile && opts.footerImageUrl) {
      settings.footerImageUrl = opts.footerImageUrl;
    }
  }

  return settings;
};
